import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Android/Chrome fires this once at page load: keep it for the install banner shown later (after login)
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__bondInstall = e;
  window.dispatchEvent(new Event('bond-install-ready'));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && !/^whistleblowing\./.test(window.location.hostname)) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}
